export default __webpack_public_path__ + "static/media/patterns-no-5.d23a1280.mid";